export default class RecruitmentClient {
    constructor(client) {
        this.client = client;
    }

    applyToVacancy(vacancyId, params) {
        return this.client.post(`/v2/recruitment/rest/v1/vacancies/${vacancyId}/applications`, params);
    }

    getVacancy(id, preferredCountry) {
        if (preferredCountry) {
            this.client.defaults.headers.common['X-Context-Country'] = preferredCountry;
        }

        return this.client.get(`/v2/recruitment/rest/v1/vacancies/${id}`);
    }

    getVacancies(preferredCountry) {
        if (preferredCountry) {
            this.client.defaults.headers.common['X-Context-Country'] = preferredCountry;
        }

        return this.client.get(`/v2/recruitment/rest/v1/vacancies`);
    }
}
